import React from "react";
import { withRouter } from "react-router-dom";

import AccountContext from "./AccountContext";

const withAccount = Component => {
  class WithAccount extends React.Component {
    render() {
      return (
        <AccountContext.Consumer>
          {account =>
            account ? <Component {...this.props} account={account} /> : null
          }
        </AccountContext.Consumer>
      );
    }
  }

  return withRouter(WithAccount);
};

export default withAccount;



// WEBPACK FOOTER //
// ./src/utils/withAccount.js